import { Helmet } from "react-helmet-async";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions</title>
      </Helmet>
      <div className="bg-black w-full min-h-screen text-white px-8 md:px-[8vw] py-12 md:py-[4vw]">
        <h1 className="text-4xl text-center md:text-left md:text-[4vw] font-bold mb-8 md:mb-12">
          Terms & Conditions
        </h1>
        <div className="w-full flex items-center justify-center">
          <h2 className="text-3xl text-center md:text-left md:text-[4vw] font-bold mb-8 md:mb-0 md:py-8">
            ToothSketch LLP Terms and Conditions
          </h2>
        </div>

        <p className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]">
          These terms and conditions are a legal agreement (“ Agreement”)
          between ToothSketch LLP (“ ToothSketch ”, “We”, “Our” or “Us “) and
          you (“Customer”, “User”) regarding the use of our professional CAD
          based design services for various dental prosthetics (including but
          not limited to crowns, abutments and dentures), accessing, browsing,
          subscribing to and using ToothSketch websites and ToothSketch’s
          web-based platform that are used for transmission and communication
          about such dental prosthetic designs as well as any other online and /
          or mobile services provided by ToothSketch (“ToothSketch service”).
        </p>

        <p className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]">
          By using the ToothSketch service, you agree that you have read,
          understood, and agree, without limitation or qualification, to be
          bound by these Terms and Conditions, whether or not you are a
          registered user of the ToothSketch service.
        </p>
        <p className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]">
          The materials provided through ToothSketch services are protected by
          Copyright laws.
        </p>
        <p className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]">
          ToothSketch is only a professional design service provider to dental
          manufacturers, laboratories and clinicians and is not providing dental
          care, treatment or any related medical advise to you. Those who choose
          to access ToothSketch services do so at their own initiative and are
          responsible for complying with the local laws that are applicable in
          their jurisdictions.
        </p>
        <p className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]">
          ToothSketch services are offered and available to users who are
          eighteen (18) years of age or older. By using these services, you
          represent and warrant that you are of legal age to form a binding
          contract with ToothSketch.
        </p>

        {data.map((item, index) => (
          <div key={index}>
            <h4 className="text-md md:text-[1.5vw] font-bold md:leading-[2vw] mt-6 md:mt-[2.5vw]">
              {item.title}
            </h4>
            {item.desc.map((descdata, index) => {
              const email = "admin@toothsketch.com";
              if (descdata.includes(email)) {
                const parts = descdata.split(email);
                return (
                  <p
                    key={index}
                    className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]"
                  >
                    {parts[0]}
                    <a
                      href={`mailto:${email}`}
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      {email}
                    </a>
                    {parts[1]}
                  </p>
                );
              } else {
                return (
                  <p
                    key={index}
                    className="text-md md:text-[1.25vw] md:leading-[2vw] mt-6 md:mt-[1.5vw]"
                  >
                    {descdata}
                  </p>
                );
              }
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default TermsConditions;

const data = [
  {
    title: "Confidentiality",
    desc: [
      "Other than the data uploaded by respective users, content and information on ToothSketch website, web-based platform and other modes of interaction are proprietary to ToothSketch or its suppliers, licensors, publishers, or other content providers. You agree not to modify, copy, distribute, transmit, share, display, perform, reproduce, publish, license, create derived works from, transfer, or sell or re-sell any ToothSketch content obtained from or through ToothSketch. In compliance with this agreement, ToothSketch content providers grant you a limited, non- exclusive, non-transferable license to access and make personal and non-commercial use of ToothSketch content. All rights not granted to you in this agreement are reserved and retained by ToothSketch content providers.",
    ],
  },
  {
    title: "Limitation of Liability",
    desc: [
      "In no event will TootkSketch be liable for any damages, including, without limitation, indirect, incidental, special, consequential or punitive damages, whether under a contract, tort, statute, implied duties or obligations or any other theory of liability, arising in connection with use of ToothSketch service, ToothSketch website or web-based platform or in connection with any failure of performance, error, omission, interruption, defect, delay in operation or transmission, computer virus, line system failure, loss of data, or loss of use related to this Website or any website operated by any third party or any contents of this Website or any other website, even if ToothSketch is aware of the possibility of such damages.",
    ],
  },
  {
    title: "Indemnity",
    desc: [
      "ToothSketch shall be indemnified, defended and held harmless from and against all losses, expenses, damages and costs, including reasonable attorneys’ fees, arising out of or relating to any misuse by users of the content and services provided by ToothSketch on website, web-based platform or otherwise. ",
    ],
  },
  {
    title: "Customer Responsibility for Finished Designs",
    desc: [
      "Customer is solely responsible for all the data that is provided to ToothSketch and should ensure itself and / or with a prescribing clinician that the designs meet the requirements of the clinician customer.",
    ],
  },
  {
    title: "No Warranty",
    desc: [
      `ToothSketch does not make any warranties or representations to its customers regarding the accuracy of any information provided to ToothSketch and the resulting designs produced.`,
      `
    ToothSketch design services are provided without warranties of any kind, whether express or implied and specifically disclaims all implied warranties, including any implied warranty of merchantability, fitness for a particular purpose or non-infringement. `,
    ],
  },
  {
    title: "Availability",
    desc: [
      "ToothSketch may publish information on ToothSketch with reference to services, programs or products that may or may not yet be launched or available in your country.  Please consult ToothSketch team for details and clarification on products and services that are available in your country. ",
    ],
  },
  {
    title: "Privacy",
    desc: [
      "For information about how ToothSketch protects your privacy, please read ToothSketch privacy policy.",
    ],
  },
  {
    title: "Mobile Terms",
    desc: [
      "If you have opted to receive special offers and updates from ToothSketch via email, SMS or otherwise, you can unsubscribe via the links provided in the email at any time or by contacting us. Message frequency varies based on user and various other factors. Message delivery is subject to effective transmission by your network operator and we will not be liable for any delays in receipt of the same by you. Data obtained from you in connection with SMS service may include your mobile phone number, your network operator, details such as date, time etc., which may be used to contact you or for other business purposes.",
    ],
  },
  {
    title: "Security",
    desc: [
      "ToothSketch cares about the integrity and security of your personal information. However, we cannot guarantee that unauthorized third parties will never be able to breakthrough our security measures or use your personal information for improper purposes. You acknowledge that you will provide your personal information at your own risk.",
    ],
  },
  {
    title: "Payments",
    desc: [
      "You agree to pay ToothSketch amounts that are specified in the payment plan opted by you, in accordance with these terms and conditions.  You hereby authorize ToothSketch to bill your payment instrument on a bi-weekly basis in accordance with the terms of the applicable payment plan until you terminate your account. Such billing will be exclusive of any charges that are incurred for the said payment. In order to process payments efficiently in an uninterrupted manner, you may be required to provide us with information regarding your credit card / other payment instrument. You represent and warrant to ToothSketch that such information is true and you are authorized to use the said payment instrument. You will keep your account information up to date for any changes that may occur (such as change in billing address, credit card expiry etc.).",
    ],
  },
  {
    title: "Refunds and Exchanges",
    desc: [
      "Once the purchase of your design service has been completed, the said purchase cannot be cancelled, returned or refunded. In the event of any dispute resulting in fees owed to you or overpayments, you understand and agree that ToothSketch shall provide a credit to your account in lieu of the same. ",
    ],
  },
  {
    title: "Changes or Updates",
    desc: [
      "Information on ToothSketch website and web-based platform may be changed or updated from time to time without prior notice. ToothSketch may also make changes and / or improvements in the services and / or products described in this information at any time without prior notice. ",
    ],
  },
  {
    title: "Entire Agreement and Severability",
    desc: [
      "This Agreement, together with any amendments and any additional agreements you may enter into with ToothSketch in connection with ToothSketch service, shall constitute the entire agreement between you and ToothSketch concerning the ToothSketch service. ",
      "If any provision of this Agreement is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of this Agreement, which shall remain in full force and effect.",
    ],
  },
  {
    title: "Termination and Suspension",
    desc: [
      "In its sole and absolute discretion, with or without notice, ToothSketch may terminate or suspend your use of and access to the ToothSketch service, terminate your account without prior notice and for any reason, including, but not limited to (i) Permitting another user to use your login details, (ii) Any unauthorized access or usage of ToothSketch, (iii) Any suspected violation of this terms and conditions and (iv) Tampering with ToothSketch service to the detrimental effect on other users. You may terminate your account within twelve (12) days notice at any time by writing to admin@toothsketch.com along with your reasons and requesting for the same.",
    ],
  },
  {
    title: "Miscellaneous",
    desc: [
      "You agree that the customer is solely responsible to obtain rights, permissions or consent from its customers that might be needed for the usage of ToothSketch service. ",
      "This agreement and all other attached or incorporated documents contain the entire agreement between the ToothSketch and the customer and supersedes any previous understanding, commitments or agreements, oral or written. ",
      "Force Majeure: Neither the Customer nor ToothSketch shall be liable for any failure to perform under this agreement when such failure is due to causes beyond reasonable control of each of them, including, but not limited to, acts of terrorism, natural catastrophe, fire, storm, floods and earthquakes. In the event of such delay the date of delivery or time for completion will be extended by a period of time reasonably necessary and mutually agreed. If the delay remains in effect for a period in excess of thirty (30) days, Customer may terminate this agreement immediately upon written notice to us.",
    ],
  },
  {
    title: "Revisions to this Agreement",
    desc: [
      "ToothSketch may from time to time revise this agreement by updating this page. All such changes will be effective immediately when posted and apply to all access to and use of ToothSketch services.",
      "By continuing to use ToothSketch service, you agree to be bound by any such revisions and thus should periodically visit this page to determine current terms to which you are bound. If you do not agree to these terms and conditions, do not use ToothSketch services. These terms and conditions apply to all visitors, users and others who access ToothSketch services.",
    ],
  },
  {
    title: "Governing Law",
    desc: [
      "ToothSketch and the client shall make a good-faith effort to amicably settle by mutual agreement any dispute that may arise between them under this agreement. The foregoing requirement will not preclude either ToothSketch or the client from seeking injunctive relief as it deems necessary to protect its own interests. This Contract will be construed and enforced in accordance with the international as well as laws of the Republic of India, New Delhi jurisdiction.",
    ],
  },
];
